/**
 * The founder's mount point for the strategic-analysis screen.
 *
 * ONE SCREEN, TWO ROUTES, AND ONLY ONE IMPLEMENTATION. The screen is reached by
 * three entry points — the founder dashboard, the founder company page, and an
 * investor's `startup-detail`. An investor is not inside the `(startup)` tab
 * navigator, so the route has to exist at the root for them; a founder IS, and
 * pushing them to the root route unmounted the tab bar mid-session. Every other
 * founder destination (`insights`, `interview`, `company`, `updates` …) lives in
 * this group with `href: null`, so leaving the tabs was the odd behaviour, not
 * keeping them.
 *
 * This file re-exports rather than reimplements. `(startup)/help.tsx` is the
 * cautionary example: it is a second, hand-maintained copy of the root help
 * screen, and the two have already drifted. A screen with a versioned report
 * contract, five analysis tabs and a per-tab readiness gate would drift faster
 * and less visibly.
 *
 * Register it in `_layout.tsx` with `href: null` — present in the navigator,
 * absent from the tab bar.
 */

export { default } from '../strategic-analysis';
